import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox } from '@/_components';

import { useGetRecruitingJobCategoriesMutation } from '../apis';
import type { RecruitingJobCategoryQueryLinkerSchema } from '../schemas';

export function RecruitingJobCategoriesMultiSelect({
  disabled,
  ...props
}: FormAsyncComboboxProps<RecruitingJobCategoryQueryLinkerSchema, true>) {
  return (
    <FormAsyncCombobox
      {...props}
      isMulti
      showBorder
      itemToString={(item) => item.name}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      getMultiValueLabel={(item) => item.name}
      useApi={useGetRecruitingJobCategoriesMutation}
      disabled={disabled}
    />
  );
}
